import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
    title: string;
}

export default function ConfigurePricing({
    open,
    onClose,
    setOpen,
    title,
}: ModalProps) {
    const [price, setPrice] = useState("");

    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <h2>Configure Pricing</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">

                            {/* Insight Title (Read-only or just label) */}
                            <div className="control_group">
                                <label htmlFor="ai-insight">AI Insight</label>
                                <TextField
                                    value={title}
                                    fullWidth
                                    disabled
                                    hiddenLabel
                                    size="small"
                                    inputProps={{ id: "ai-insight" }}
                                />
                            </div>

                            {/* Price */}
                            <div className="control_group">
                                <label htmlFor="enter-price">Enter Price (AED)</label>
                                <TextField
                                    placeholder="e.g., 99"
                                    fullWidth
                                    hiddenLabel
                                    size="small"
                                    value={price}
                                    onChange={(e) => setPrice(e.target.value)}
                                    type="number"
                                    inputProps={{ id: "enter-price" }}
                                />
                            </div>

                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                variant="outlined"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Save
                            </Button>
                        </div>
                    </form>

                </div>
            </div>
        </Modal>
    );
}
